/* eslint eol-last: ["error", "never"] */
export default {
    loadingForm: false,
    loadingFormSave: false,
    formacioneslist: true,
    formacionesadd: false,
    formaciones: [],
}